<template>	
	<div>
		<flCarregando v-if="loading" />
		<div v-if="!loading">
			<div style="color: #AAA; position:fixed; bottom:20px; left:10px" class="text-center">
				<!-- <small v-if="config">{{ config.versao }} | {{ _getVersao() }} </small> -->
			</div>

			<div>
				<div class="container login" style="display:flex;justify-content: center;align-items: center;"
					:style="{ 'height': _height + 'px' }">
					<div style="flex:1">
						<div class="row">
							<div class="col-1 col-sm-1 col-md-3 col-lg-4 col-xl-4"></div>
							<div class="col-10 col-sm-10 col-md-6 col-lg-4 col-xl-4">
								<div class="animated fadeInDown">
									<div class="row">
										<div class="col-12 text-center">
											<img class="animated fadeInDown img-fluid"
												src="../../assets/img/followair_services.png" />
										</div>
										<div class="col-12 animated fadeInUp">
											<form @submit.prevent="validateBeforeSubmit">
												<div class="row form-group">
													<div class="col-12">
														<fa-icon class="icon" fill="" icon="user"></fa-icon>
														<input type="text" name="email" v-model="login"
															class="form-control input radius-60" placeholder="Email">
													</div>
												</div>
												<div class="row form-group">
													<div class="col-12">
														<fa-icon class="icon" fill="" icon="key"></fa-icon>
														<input type="password" name="senha" v-model="senha"
															class="form-control input radius-60" placeholder="Senha">
													</div>
												</div>

												<div class="row">
													<div class="col-12">
														<button class="btn btn-primary btn-block radius-60"
															type="submit">
															ENTRAR
														</button>
													</div>
												</div>
											</form>
										</div>
									</div>
								</div>

							</div>
						</div>
					</div>


				</div>
			</div>
		</div>

	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import $ from "jquery";
import axios from '../../routers/axios'
import local from '../../config/local-storage'
import flCarregando from '../../components/carregando/main.vue'
var jwt_token = require('jwt-decode')
export default {

	components: {
		flCarregando
	},

	data() {
		return {
			login: "",
			senha: "",
			versaoAPI: "",
			loading: false,
		};
	},

	computed: {
		...mapState({
			user: state => state.sessao.user,
			webSocket: state => state.sessao.webSocket,
			config: state => state.sessao.config
		}),
	},

	watch: {
		webSocket(val) {
			if (val) {
				if (this._getPrivilegio(1)) {
					this.$router.push({ name: "monitoramento" });
				} else {
					this.$router.push({ name: "inicio" });
				}

				this.$notify.loadOut()
			}
		}
	},

	mounted() {

		document.body.style.background = "#263238"

		if (sessionStorage.getItem(local.localBaseURL) == null) {

			this.loading = true
			axios.get(window.location.href.split("#")[0] + 'config.json?' + this._getVersao()).then(response => {

				this.setBaseURL(response.data.ws)
				this.loading = false
				this.carregaVesao()

			})
		}
	},

	methods: {

		...mapActions(['setSession', 'setConfig', 'setBaseURL']),


		carregaVesao() {
			if (this.config == null) {

				this.$notify.loadIn('Conectando')

				axios.get(this._getUrl("api/sistemaconfig")).then(response => {
					this.setConfig(response.data)

				})
			}
		},

		validateBeforeSubmit() {
			this.$validator.validateAll().then(result => {
				if (result) {
					this.validaLogin();
					return;
				}
			});
		},

		setSessao(token, area) {
			// Pega a informacao
			var dados = jwt_token(token)
			//console.log("token", dados)

			var session = {
				token: token,
				nome: dados.nome,
				cpf: dados.cpf,
				login: dados.login,
				exp: dados.exp,
				cargo: dados.cargo,
				departamento: dados.departamento,
				email: dados.email,
				id_usuario: dados.id_usuario,
				telefone: dados.telefone,
				telefone2: dados.telefone2,
				msg: false,
				privilegios: dados.privis,
				area: area,
				foto: dados.foto,
				id_orgao: dados.id_orgao,
				trigrama: dados.trigrama,
				anac: dados.codigo_anac,
				desenvolvedor: dados.desenvolvedor == '0' ? false : true
			}

			var string = JSON.stringify(session)
			sessionStorage.setItem('_POLICE_SESSION_', string)
		},

		validaLogin() {
			if (!this.login.includes("@") && this.login != '') {
				this.login += "@tsaaviacao.com.br";
			}

			this.$notify.loadIn('Carregando');
			var data = {
				login: this.login,
				senha: this.senha
			};

			axios.post(this._getUrl("api/acesso"), data).then(response => {
				var dadosResp = jwt_token(response.data)

				window.scrollTo(0, document.body.scrollHeight);

				this.$notify.loadIn('Conectando')

				this.setSession(response.data)

				// so redireciona para o sistema assim que conecta no websoket
				// event WebSocketConnected
				// watch webSocket
				this._webSoketConnect()
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.login {

	img {
		margin-bottom: 2em;
	}

	.input {
		background: #263238;
		color: #CFD8DC;
		border-color: #90A4AE;
	}

	.input::placeholder {
		color: #CFD8DC;
	}

	.icon {
		position: absolute;
		right: 30px;
		top: 11px;
		color: #CFD8DC;
	}

	.radius-60 {
		border-radius: 60px
	}
}
</style>



// WEBPACK FOOTER //
// src/views/login/main.vue